import { unstable_rethrow } from 'next/navigation';
import { useCallback } from 'react';

import { GoogleLoginSuccessCallback } from '../google-login/useGoogleLoginIFrameEventListener';
import { RecaptchaAction } from './RecaptchaAction';
import { useRecaptchaCallback } from './useRecaptchaCallback';

export interface GoogleCallbackConfig {
    action: RecaptchaAction.LOGIN_WITH_GOOGLE | RecaptchaAction.SIGN_UP_WITH_GOOGLE;
    onSuccess: (googleCredential: string, recaptchaToken: string | undefined) => Promise<void>;
    onError: (error: Error) => void;
}

export function useGoogleCallback({ action, onSuccess, onError }: GoogleCallbackConfig): GoogleLoginSuccessCallback {
    const recaptchaCallback = useRecaptchaCallback(action);

    return useCallback<GoogleLoginSuccessCallback>(
        (response) => {
            const { credential } = response;

            recaptchaCallback()
                .then((recaptchaToken) => {
                    return onSuccess(credential, recaptchaToken);
                })
                .catch((error: Error) => {
                    // Let Next.js control-flow errors (e.g. redirect from a server action) bubble up to the router.
                    unstable_rethrow(error);
                    onError(error);
                });
        },
        [recaptchaCallback, onSuccess, onError],
    );
}
